import { apiBuilder } from "@zodios/core";
import { z } from "zod";

const assetSchema = z
  .object({
    asset_id: z.string(),
    name: z.string().nullable().optional(),
    type: z.string(),
    subtype: z.array(z.string()).nullable(),
    tags: z.array(z.string()).optional(),
    url_default: z.string(),
    file_meta_data: z.record(z.any()),
  })
  .passthrough();

const assetsResponseSchema = z
  .object({
    results: z.array(assetSchema),
  })
  .passthrough();

export const assetsApiDefinitions = apiBuilder({
  alias: "getAssets",
  method: "get",
  path: "/assets/",
  parameters: [
    { name: "type", type: "Query", schema: z.enum(["IMAGE", "VIDEO"]).optional() },
    { name: "subtype", type: "Query", schema: z.string().nullable().optional() },
    { name: "name", type: "Query", schema: z.string().nullable().optional() },
    { name: "min_file_size", type: "Query", schema: z.number().nullable().optional() },
    { name: "max_file_size", type: "Query", schema: z.number().nullable().optional() },
    { name: "min_height", type: "Query", schema: z.number().nullable().optional() },
    { name: "min_width", type: "Query", schema: z.number().nullable().optional() },
    { name: "moderation_request_status", type: "Query", schema: z.string().nullable().optional() },
    { name: "tags", type: "Query", schema: z.string().nullable().optional() },
    { name: "marketplace", type: "Query", schema: z.string().nullable().optional() },
    { name: "asset_source", type: "Query", schema: z.string().nullable().optional() },
    { name: "asset_id", type: "Query", schema: z.number().nullable().optional() },
  ],
  status: 200,
  response: assetsResponseSchema,
}).build();
